import { Component, OnInit, EventEmitter, Output, Input, OnChanges, SimpleChanges, HostListener, ElementRef } from '@angular/core';
import { AppConfig } from '../../AppConfig';
import { Router } from '@angular/router';

const enlaces = new Map<string, string>();
//enlaces.set('mas', 'Conoce Más');
enlaces.set('precios', 'Precios');
enlaces.set('pagos', 'Forma de pago');
enlaces.set('info', 'Información Adicional');
enlaces.set('proceso', 'Proceso de venta');
enlaces.set('contacto', 'Directorio');
//enlaces.set('consejos', 'Consejos');
enlaces.set('faq', 'Preguntas frecuentes');
enlaces.set('interes', 'Sitios de interés');
enlaces.set('tutorial', 'Tutorial');
enlaces.set('quienes', 'Quiénes somos');
//enlaces.set('quienesSomos2', 'Quiénes Somos');
enlaces.set('glosario', 'Glosario');
enlaces.set('detalle', 'Detalle del inmueble');
enlaces.set('inmuebles', '¿Qué estás buscando?');

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})


export class HeaderComponent implements OnInit, OnChanges {
  
  @Output() valueChange = new EventEmitter();
  @Input() url: any;
  desplegado: boolean = false;
  breadcrumb: string[] = [];
  dropdownOpen = false;
  conoceMasRotation: number = 0;

  constructor( public appConfig: AppConfig,
              private router: Router,
              private elementRef: ElementRef ) {
  }

  toggleDropdown(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dropdownOpen = !this.dropdownOpen;
  }

  onNavClick(event: Event) {
    const link = event.target as HTMLElement;
    link.classList.add('active');
    setTimeout(() => {
      link.classList.remove('active');
    }, 200);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
   if (this.dropdownOpen && !this.elementRef.nativeElement.querySelector('.dropdown-menu').contains(event.target)) {
    this.dropdownOpen = false;
   }
  }

  ngOnInit() {
  }

  ngOnChanges( changes:  SimpleChanges ) {
    let currentUrl = changes['url'];
    this.url = currentUrl.currentValue;
    this.routear(this.url);
  }

  public direccionar( key: string ): void {
    this.router.navigate(['/path', this.appConfig.getConfig( key )]);
  }

  valueChanged() {
    this.desplegado =! this.desplegado;
    this.valueChange.emit(this.desplegado);
  }

  public routear( ruta: string ): void {
    this.getValue( ruta );
  }

  public getValue(pattern: string) {
    this.breadcrumb = [];

    if (!pattern || pattern === '/') return;
    const conoceMasKeys = ['proceso', 'faq', 'interes'];
    const isConoceMas = conoceMasKeys.some(key => pattern.includes(key));

    if (isConoceMas) {
      this.breadcrumb.push('Conoce más');
      const finalKey = conoceMasKeys.find(key => pattern.includes(key));

      if (finalKey) {
        const value = enlaces.get(finalKey);
        if (value) this.breadcrumb.push(value);
      }

    } else {
      for (const [key, value] of enlaces) {
        if (pattern.includes(key)) {
          this.breadcrumb.push(value);
          break;
        }
      }
    }
  }

  public capitalizeFirstLetter(texto: string): string {
    if (!texto) return '';
    return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
  }

}
